; (function (inovestor, undefined) {
    // Create plugin namespace with any desired config variable
    inovestor.ms.fund = inovestor.ms.fund || {};
})(inovestor);


; (function (fund, undefined) {
    // Create plugin namespace with any desired config variable
    fund.summary = {
        config: {
            apiRelativeUrl: 'mutualfunds/summary?symbol={symbol}'
        }
    };

})(inovestor.ms.fund);


; (function ($, ko, inovestor, undefined) {
    inovestor.ms.fund.summary.viewModels = {};

    inovestor.ms.fund.summary.viewModels.summaryViewModel = function (plugin) {
        var self = this;

        self.pdfReportUrl = plugin.options.pdfReportUrl;
        self.pdfHandler = plugin.options.pdfHandler;

        self.summary = ko.observable();
        self.resources = ko.observable();
        self.hasError = ko.observable(false);
        self.isInvalidIdentifier = ko.observable(false);
        self.hasValidData = ko.computed(function () {
            return !self.hasError() && !self.isInvalidIdentifier() && self.summary() != null;
        }, this);

        self.updateResources = function () {
            // Update main resources
            var currentResource = inovestor.ms.fund.summary.resources[inovestor.ms.core.currentLanguage];
            if (inovestor.ms.core.isNullOrUndefined(currentResource))
                currentResource = null;
            self.resources(currentResource);
        };
    }

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function ($, ko, inovestor, undefined) {

    var pluginName = 'inoMsFundSummary';

    // Create the plugin constructor
    function Plugin(element, options) {

        this.element = element;
        this._name = pluginName;
        this._defaults = $.fn.inoMsFundSummary.defaults;
        
        // Merge options with defaults
        this.options = $.extend({}, this._defaults, options);

        this._viewModel = new inovestor.ms.fund.summary.viewModels.summaryViewModel(this);

        // Make sure required variables are set
        if (inovestor.ms.core.isNullOrUndefined(this.options.symbol))
            throw "symbol is required";

        // Call init
        this.init();
    }

    $.extend(Plugin.prototype, {

        // Initialization logic
        init: function () {
            var plugin = this;

            // Setup what plugin needs to do on language change
            inovestor.ms.core.instances.register(this, function () {
                plugin.update();
            });
            
            // Plugin overrides for template = cacheKey and path are the same
            var fileCacheKey = plugin.options.templatePaths.summary;
            var filePath = plugin.options.templatePaths.summary;
            // Default behavior (if no template path is set by plugin)
			if (inovestor.ms.core.isEmptyString(fileCacheKey)) {
                var fileName = 'summary.html';
                fileCacheKey = pluginName + '.' + fileName;
                filePath = (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) ? '' : inovestor.ms.core.config.templateRootUrl) +
                    (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) || inovestor.ms.core.config.templateRootUrl.match(/\/$/) != null ? '' : '/') + // check if templateRootUrl ends in slash
                    (this._name + '/' + fileName);
            }

            // Get main template file
            inovestor.ms.core.getTemplate(fileCacheKey, filePath).then(function (template) {
                $(plugin.element).html(template);
                plugin.buildCache();
                plugin.bindEvents();
                plugin.render();
                plugin.bindModel();
            }).then(function () {
                // Call Search
                plugin.search(plugin.options.symbol).always(function () {
                    // When search is completed, trigger onReady event
                    plugin.$element.trigger('ready' + '.' + plugin._name);
                });
            });
        },

        // Remove plugin instance completely
        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        // Cache DOM nodes for performance
        buildCache: function () {
            this.$element = $(this.element);
        },

        // Bind events that trigger methods
        bindEvents: function () {
            var plugin = this;
            plugin.$element.on('ready' + '.' + plugin._name, function () {
                var onReady = plugin.options.onReady;
                if (typeof onReady === 'function')
                    onReady.call(plugin.$element);
            });
        },

        // Unbind events that trigger methods
        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        // API error handler
        apiErrorHandler: function (apiError) {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.apiError, apiError, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.hasError(true);
        },

        // Invalid Identifier error handler
        invalidIdentifierHandler: function () {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.invalidIdentifier, null, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.isInvalidIdentifier(true);
        },

        // Search for a particular fund
        search: function (symbol) {
            var plugin = this;

            // Make sure required variables are set
            if (inovestor.ms.core.isNullOrUndefined(symbol))
                throw "symbol is required";

            // Update options
            plugin.options.symbol = symbol;

            // Setup API url with term
            var fundSummaryUrl = inovestor.ms.core.stringFormat(inovestor.ms.fund.summary.config.apiRelativeUrl, { symbol: symbol });

            // Reset relevant Data before calling API
            plugin._viewModel.summary(null);
            plugin._viewModel.hasError(false);
            plugin._viewModel.isInvalidIdentifier(false);

            // Call API and bind model
            var options = { type: 'GET', contentType: 'application/json', error: function (error) { plugin.apiErrorHandler(error); } };
            return inovestor.ms.core.ajaxApi(fundSummaryUrl, options).then(function (data) {
                if (!inovestor.ms.core.isNullOrUndefined(data)) {
                    if (data.requestStatus === 'invalidIdentifier')
                        plugin.invalidIdentifierHandler();

                    plugin._viewModel.summary(data);
                }
                plugin.update();
            });
        },

        // Renders html template and binds model (should be called once)
        render: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
        },

        // Update resources
        update: function () {
            var plugin = this;
            // Update view model resources
            plugin._viewModel.updateResources();
            plugin._viewModel.summary.valueHasMutated();
        },

        // Applies knockout bindings to element. (Should be done only once)
        bindModel: function () {
            var plugin = this;
            ko.applyBindings(plugin._viewModel, plugin.element);
        },
    });

    // JQuery Plugin wrapper
    $.fn.inoMsFundSummary = function (options) {
        this.each(function () {
            if (!$.data(this, pluginName)) {
                // Store instance of plugin in "$.data"
                $.data(this, pluginName, new Plugin(this, options));
            }
        });

        // return plugin to support JQuery chaining
        return this;
    };

    // Default options for plugin
    $.fn.inoMsFundSummary.defaults = {
        symbol: null,
        onError: null,
        onReady: null,
        pdfReportUrl: null,
        pdfHandler: null,
        templatePaths: {
            summary: null
        },
    };

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function (fund, undefined) {
    fund.summary.resources = fund.summary.resources || {};
    fund.summary.resources["en"] = {
        annualisedReturn5Years: 'Annualized 5-Year Return',
        asOf: 'As of',
        category: 'Category',
        fundgrade: 'FundGrade',
        fundgradeInfo: 'Score based on risk-adjusted performance. A = best, E = worst.',
        netAssetInfo: 'For this Fund Series only',
        inceptionDate: 'Inception Date',
        managementFees: 'Management Fees',
        managementFeesRatio: 'MER',
        minimumInvestment: 'Min. Investment',
        aum: 'AUM',
        oneYearReturn: '1-Year Return',
        currentYield: 'TTM Yield',
        currentYieldInfo: 'Past 12m',
        ytdReturn: 'YTD Return',
        distributionTtmYield: 'Distribution Yield (TTM)',
        distributionTtmYieldInfo: "TTM Distribution Yield refers to trailing twelve months distribution divided by the previous day close.",
        load: "Load",
        isChoiceOfFrontOrBackFee: "Choice of front or back ",
        rrspEligible: "RRSP",
        investementObjective: "Objective",
        investementStrategy: "Strategy",
        no: "No",
        yes: "Yes",
        downloadPdf: "DOWNLOAD PDF"
    };
})(inovestor.ms.fund);

; (function (fund, undefined) {
    fund.summary.resources = fund.summary.resources || {};
    fund.summary.resources["fr"] = {
        annualisedReturn5Years: 'Rendement annualisé 5 ans',
        asOf: 'Au',
        category: 'Catégorie',
        fundgrade: 'FundGrade',
        fundgradeInfo: 'Calculé à partir des performances ajustées au risque. A = meilleur, E = moins bon',
        netAssetInfo: 'Pour cette série de fonds seulement',
        inceptionDate: 'Création',
        managementFees: 'Frais de gestion',
        managementFeesRatio: 'RFG',
        minimumInvestment: 'Investissement min.',
        aum: 'Actifs sous gestion',
        oneYearReturn: 'Rendement 1 an',
        currentYield: 'Rend. 12m',
        currentYieldInfo: 'Dernier 12 mois',
        ytdReturn: 'Rendement AACJ',
        distributionTtmYield: 'Distribution (DDM)',
        distributionTtmYieldInfo: "Rendement des distributions sur 12 mois (TTM) fait référence à la distribution des douze derniers mois, divisée par la clôture de la veille.",
        load: "Structure de frais",
        isChoiceOfFrontOrBackFee: "Frais souscription/rachat",
        rrspEligible: "REER autorisé",
        investementObjective: "Objectif",
        investementStrategy: "Stratégie",
        no: "Non",
        yes: "Oui",
        downloadPdf: "TÉLÉCHARGER PDF",
    };
})(inovestor.ms.fund);
